import i18n from '@/utils/i18n';

export type LocaleOption = {
  value: string;
  label: string;
  i18nKey: string;
};

/**
 * Get supported locale options for preferred locale selection.
 * Returns options evaluated at runtime with current i18n state.
 * Used in Analytics Users and Store management.
 */
export function getPreferredLocaleOptions(): LocaleOption[] {
  return [
    {
      value: '',
      label: i18n.t('GeneralAdminInfo:preferredLocaleNone'),
      i18nKey: 'GeneralAdminInfo:preferredLocaleNone',
    },
    {
      value: 'de-DE',
      label: `🇩🇪 ${i18n.t('GeneralAdminInfo:localeDeDE')}`,
      i18nKey: 'GeneralAdminInfo:localeDeDE',
    },
    {
      value: 'en-GB',
      label: `🇬🇧/🇺🇸 ${i18n.t('GeneralAdminInfo:localeEnGB')}`,
      i18nKey: 'GeneralAdminInfo:localeEnGB',
    },
    {
      value: 'es-ES',
      label: `🇪🇸 ${i18n.t('GeneralAdminInfo:localeEsES')}`,
      i18nKey: 'GeneralAdminInfo:localeEsES',
    },
    {
      value: 'ca-ES',
      label: `🇪🇸 ${i18n.t('GeneralAdminInfo:localeCaES')}`,
      i18nKey: 'GeneralAdminInfo:localeCaES',
    },
    {
      value: 'fr-FR',
      label: `🇫🇷 ${i18n.t('GeneralAdminInfo:localeFrFR')}`,
      i18nKey: 'GeneralAdminInfo:localeFrFR',
    },
    {
      value: 'nl-NL',
      label: `🇳🇱 ${i18n.t('GeneralAdminInfo:localeNlNL')}`,
      i18nKey: 'GeneralAdminInfo:localeNlNL',
    },
    {
      value: 'pt-PT',
      label: `🇵🇹 ${i18n.t('GeneralAdminInfo:localePtPT')}`,
      i18nKey: 'GeneralAdminInfo:localePtPT',
    },
    {
      value: 'sq-AL',
      label: `🇦🇱 ${i18n.t('GeneralAdminInfo:localeSqAL')}`,
      i18nKey: 'GeneralAdminInfo:localeSqAL',
    },
    {
      value: 'el-GR',
      label: `🇬🇷 ${i18n.t('GeneralAdminInfo:localeElGR')}`,
      i18nKey: 'GeneralAdminInfo:localeElGR',
    },
  ];
}

/**
 * Get the display label for a locale value
 */
export function getLocaleLabel(value: string | null | undefined): string {
  if (!value) {
    return i18n.t('GeneralAdminInfo:preferredLocaleNone');
  }
  const options = getPreferredLocaleOptions();
  const option = options.find((opt) => opt.value === value);
  return option?.label || value;
}
